import React from 'react';
import { withToastManager } from 'ui/toast';
import { useHistory, useParams } from 'react-router-dom';
import DragDropSurveyLayout from './DragDropSurveyLayout';
import FileDropzoneSquare from './FileDropzoneSquare';
import { useCSVFileUpload } from 'hooks/surveys';
import { useProjectWithErrorHandling } from 'hooks/projects/useProjectWithErrorHandling';

function SurveyUploadingContainer({ projectID, toastManager }) {
  // Check if project exists and handle 404
  const { NotFoundComponent } = useProjectWithErrorHandling(projectID);
  
  const { csvFileID } = useParams();
  const history = useHistory();

  const { data: csvFile, error } = useCSVFileUpload(csvFileID, projectID);

  // v5 removed useQuery onSuccess/onError — react to data/error instead
  React.useEffect(() => {
    if (!csvFile) return;
    if (csvFile.status === 'completed') {
      history.push(`/surveys/${csvFile.survey_id}`);
    } else if (csvFile.status === 'failed') {
      toastManager.add(`Error uploading CSV: ${csvFile.error_log}`, { appearance: 'error', autoDismiss: false });
      history.push(`/projects/${projectID}/surveys/new`);
    }
  }, [csvFile, history, projectID, toastManager]);

  React.useEffect(() => {
    if (!error) return;
    toastManager.add('Error uploading csv.', { appearance: 'error', autoDismiss: false });
    history.push(`/projects/${projectID}/surveys/new`);
  }, [error, history, projectID, toastManager]);
  
  if (NotFoundComponent) {
    return <NotFoundComponent />;
  }
  
  return (
    <DragDropSurveyLayout>
      <FileDropzoneSquare
          isHover={false}
          nonHoverText={'Uploading CSV...'}
          loading={true}
      />
    </DragDropSurveyLayout>
  );
}

export default withToastManager(SurveyUploadingContainer);
